/**
 * Console switches that are flipped in code, not per system.
 *
 * `SHOW_ASSISTANT`: whether the console shows the automated first responder
 * at all: the Assistant chip and filter in the queue, the Assistant and
 * Escalated chips on a row, the "Take over" notice and the escalation reason
 * in the panel. Off, a session the assistant handled shows like any other;
 * the data hooks still read and fold those sessions, nothing is lost.
 */
export const SHOW_ASSISTANT = false;
